import React from 'react';

import Badge, {BadgeColor} from 'ui-library/Badge';

function BetaBadge(): JSX.Element {
  return (
    <Badge color={BadgeColor.YELLOW} bold={true}>
      Beta
    </Badge>
  );
}

export default BetaBadge;
